import { TControlledFormComponentProps } from '@chocolate-soup-inc/cs-frontend-components';
import { TChildBirthday, TEventTypes, TGiftPackageType, TWorkAnniversaryGiftVariations } from '../../generated/graphql';
import { getReadableGiftPackageSubType, getReadableGiftPackageType } from './shared';
import _ from 'lodash';

export type TGetGiftPackageFormFieldsProps = { label: string; value: string }[] | null;

export const subtypeOptions: Record<string, TGetGiftPackageFormFieldsProps> = {
  [TGiftPackageType.WorkAnniversary]: Object.values(TWorkAnniversaryGiftVariations).map((wa) => ({
    label: getReadableGiftPackageSubType(wa),
    value: wa
  })),
  [TGiftPackageType.ChildBirthday]: Object.values(TChildBirthday).map((cb) => ({
    label: getReadableGiftPackageSubType(cb),
    value: cb
  })),
  [TGiftPackageType.OneOff]: Object.values(_.omit(TEventTypes, ['Birthday', 'WorkAnniversary', 'NewHire', 'Other', 'CustomBricks'])).map((of) => ({
    label: getReadableGiftPackageSubType(of),
    value: of
  }))
};
export const getGiftPackageFormFields = (products?: TGetGiftPackageFormFieldsProps, companies?: TGetGiftPackageFormFieldsProps) => {
  const formFields: TControlledFormComponentProps[] = [
    {
      name: 'name',
      label: 'Package/Kit Name',
      type: 'textField',
      //disabled: true,
      inputOptions: (data: Record<string, any>) => {
        const companyName = companies?.find((c) => c.value == data.companyId)?.label;
        return {
          multiline: false,
          variant: 'outlined',
          value: `${data.companyId ? companyName : 'Default'} ${data.type ? getReadableGiftPackageType(data.type) : ''} ${data.subType ? getReadableGiftPackageSubType(data.subType) : ''}`
        };
      }
    },
    {
      type: 'select',
      label: 'Package Gift Type',
      name: 'type',
      inputOptions: {
        variant: 'outlined',
        multiple: false,
        options: Object.values(TGiftPackageType).map((gp) => ({ label: getReadableGiftPackageType(gp), value: gp }))
      }
    },
    {
      type: 'select',
      label: 'SubType',
      name: 'subType',
      disabled: (data) => {
        if (data.type == TGiftPackageType.WorkAnniversary && data.companyId) return true;
        if (![TGiftPackageType.ChildBirthday, TGiftPackageType.WorkAnniversary, TGiftPackageType.OneOff].includes(data.type)) return true;
        return false;
      },
      inputOptions: (data: Record<string, any>) => ({
        includeEmptyOption: true,
        variant: 'outlined',
        options: subtypeOptions[data.type] || [],
        multiple: false
      })
    },
    {
      type: 'select',
      label: 'Products',
      name: 'products',
      inputOptions: {
        options: products || [],
        multiple: true
      }
    },
    {
      type: 'switch',
      label: 'Is Default?',
      name: 'isDefault',
      inputOptions: (data: Record<string, any>) => {
        const value = !data.companyId ? true : false;
        return {
          value
        };
      }
    }
  ];

  if (companies)
    formFields.push({
      type: 'select',
      disabled: companies.length === 0,
      label: 'Company',
      name: 'companyId',
      inputOptions: {
        includeEmptyOption: true,
        variant: 'outlined',
        options: companies || []
      }
    });

  return formFields;
};
